import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        component: () => import('../views/Home')
    },
    {
        path: '/product_1',
        component: () => import('../views/Product_1')
    },
    {
        path: '/product_2',
        component: () => import('../views/Product_2')
    },
    {
        path: '/product_3',
        component: () => import('../views/Product_3'),
    },
    {
        path: '/company_info',
        component: () => import('../views/CompanyInfo')
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

export default router
